module.exports = __webpack_public_path__ + "static/img/dataLeakInstallForWin_pic14.5dfa464.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dataLeakInstallForWin/dataLeakInstallForWin_pic14.png
// module id = 492
// module chunks = 1